import React from "react";

import "../../Styles/contact.css";
import Form from "./contactform";

const ContactUs = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div className="main-page-contianer">
      <div className="careers-bg-container">
        <div className="width-wrapper">
          <div className="wrap-contact-card-1">
            <h1>Let’s Connect – We’re Here to Help</h1>
            <p>
              Reach out to learn more about Ann, request a demo, or ask us
              anything.
            </p>
          </div>
        </div>
      </div>
      <div className="form-container">
        <Form />
      </div>

      <div className="wrap-contact-card-2">
        <div className="width-wrapper">
          <div className="wrap-contact-card">
            <h3>We are always happy to assist you</h3>
            <div className="wrap-contact-1">
              <p>Email Address</p>
              <hr />
              <p>sureshdatla@sapiensfirst.com</p>
              <p>
                Assistance hours: <br />
                Monday - Friday 10 AM to 8 PM IST
              </p>
            </div>
            <div className="wrap-contact-1">
              <p>Number</p>
              <hr />
              <p>+91 95680 02281</p>
              <p>
                Assistance hours: <br />
                Monday - Friday 10 AM to 8 PM IST
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
